import { Button, Card, Col, ConfigProvider, Flex, Layout, Row, theme } from "antd"
import { Content } from "antd/es/layout/layout";
import thTH from 'antd/locale/th_TH';
import flowchart from '../img/flowchart.jpg'



export const Firstpage: React.FC = () => {
    const {
        token: { colorBgContainer, borderRadiusLG },
      } = theme.useToken();
    return <>
    <ConfigProvider 
        locale={thTH}
        theme={{
          components: {
            Table: {
              bodySortBg:"white",
              headerBg:"#8EA3A6",
              rowHoverBg:"#E6E9AF",
              footerBg:"#8EA3A6",
              headerColor:"white",
              colorBgContainer:'white',
              headerSortHoverBg: '#748b8f',
              headerSortActiveBg: '#7b979c',
              
            },
           
            Card:{
              colorBgContainer:'white'
            },
            Menu: {
              fontFamily: 'kanit',
              itemBg: "#white",
              itemColor: "#693f21",
              itemHoverColor: "white",
              itemSelectedBg: "#ffb6b5",
              itemSelectedColor: "#805b5b",
              subMenuItemSelectedColor:"#805b5b",
              popupBg:"black"
            },
            Layout: {
              siderBg: "#FFDBB5",
              headerBg: "#954C2E",

            },
            Input: {
              activeBg: 'white',
              hoverBg: 'white',
            },
            Select: {
              optionSelectedColor: '#8174A0',
              optionActiveBg: "#E5E1DA",
              controlItemBgActive: '#E5E1DA'
          },
          },
          token: {
            fontSize: 16,
            fontFamily: 'Kanit',
            // colorBgBase: '#bfb6a8',
            colorBgElevated: 'white',
            colorBorder: "#179BAE",
          }
        }}
      >
    <Layout>
        <Layout>
            <div 
            style={{
                minHeight: '100vh', 
                background: '#F7EEDE',
            }}>
            <Content
                style={{
                    margin: '25px 70px',
                    padding: 24,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                    marginTop: '80px',
                    display: 'flex',      
                    flexDirection: 'column', 
                    overflowY: 'auto',  
                }}
                >
            <Card style={{padding:0,backgroundColor:'#E2C588'}}>
                <Flex justify='center'>
                    <h1 style={{color:'white'}}>ยินดีต้อนรับสู่ระบบยื่นขอจริยธรรมวิจัย มหาวิทยาลัยวงษ์ชวลิตกุล</h1>
                </Flex>
            </Card>
           <br/>
            <Flex justify='center'>
                <p>การยื่นข้อมูลเข้าสู่ระบบจริยธรรมจะมีขั้นตอนดังแผนผังด้านล่างนี้ หากท่านเข้าใจแล้ว สามารถกด รับทราบ ที่ท้ายหน้า เพื่อไปยังหน้าเพิ่มข้อมูลได้</p>
            </Flex>
            <Flex justify='center'>
                <img src={flowchart}
                    style={{ 
                        width: '90%',        
                        height: 'auto',     
                        objectFit: 'contain',
                        marginBottom: '1rem'  
                    }} />
            </Flex>
            <Row gutter={16} align="stretch">
              <Col span={12}>
                <Card
                  style={{
                    margin: 5,
                    height: "100%",
                    backgroundColor:'#FFA239'
                  }}
                >
                  <h2 style={{color:'white' }}>รอบการแต่งตั้งพิจารณาโครงการวิจัย</h2>
                  <p style={{ textIndent: "2em",color:'white' }}>
                    คณะกรรมการจริยธรรมการวิจัยจะดำเนินการพิจารณาโครงการวิจัยตามรอบการประชุมที่กำหนดไว้
                    <span style={{ fontWeight: "bold",color: "red" }}>ทุกวันอังคารของสัปดาห์</span>&nbsp;
                    ผู้วิจัยต้องส่งโครงการเพื่อเข้ารับการพิจารณาภายในวันอังคารของสัปดาห์นั้น
                    หากส่งหลังจากวันอังคาร โครงการดังกล่าวจะถูกเลื่อนเข้ารอบการพิจารณาในสัปดาห์ถัดไป
                  </p>
                </Card>
              </Col>

              <Col span={12}>
                <Card
                  style={{
                    margin: 5,
                    height: "100%",
                    backgroundColor:'#BBC863'
                  }}
                >
                  <h2 style={{color:'white' }}>กรณีงานวิจัยนวัตกรรมสำหรับนักศึกษา</h2>
                  <p style={{ textIndent: "2em",color:'white' }}>
                    หากต้องการให้ออกใบรับรองจริยธรรมวิจัยในมนุษย์เป็นชื่ออาจารย์ที่ปรึกษาเพื่อใช้ประโยชน์ในการตีพิมพ์เผยแพร่
                    &nbsp;<span style={{ fontWeight: "bold",color:'red' }}>กรุณากรอกข้อมูลหัวหน้าโครงการวิจัยเป็นชื่ออาจารย์ที่ปรึกษา</span>
                  </p>
                </Card>
              </Col>
            </Row>

            <br/>
            <Flex justify='center' >
                <Button onClick={()=>{
                    sessionStorage.setItem('role','researcher')
                    window.location.reload()
                }}>รับทราบ</Button>
            </Flex>
            </Content>
            </div>
        </Layout>
    </Layout>
      </ConfigProvider>
    </>
}